var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"row pt-0 pr-sm-5 pl-sm-5"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('CampaignList')],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }